/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespDetails_item = {|
  +pdpDetailsDisplay: ?$ReadOnlyArray<?"ARTIST" | "BRAND" | "BUST" | "CONDITION" | "CREATOR" | "DATE_OF_MANUFACTURE" | "DESIGNER" | "DEALER_LOCATION" | "DEALER_REFERENCE" | "DIAMETER" | "DIMENSIONS" | "HIP" | "INSEAM" | "IN_THE_STYLE_OF" | "ITEM_LOCATION" | "LENGTH" | "MARKED_SIZE" | "MATERIALS_AND_TECHNIQUES" | "MATERIAL_NOTES" | "METAL" | "MOVEMENT_AND_STYLE" | "MEDIUM" | "NUMBER_OF_ITEMS" | "SET_SIZE" | "OF_THE_PERIOD" | "PLACE_OF_ORIGIN" | "PERIOD" | "PRODUCTION_TIME" | "PRODUCTION_TYPE" | "REFERENCE_NUMBER" | "SEAT_HEIGHT" | "SHOULDER_TO_HEM" | "STONE" | "STONE_CUT" | "WAIST" | "WEAR" | "WEIGHT" | "VERSIONS">;
  +vertical: ?"furniture" | "fashion" | "jewelry" | "art";
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetails_item",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailMaterialsAndTechniques_item",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pdpDetailsDisplay",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailBust_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailCondition_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailCreator_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailDealerLocation_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailDealerReference_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailDiameter_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailDimensions_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailHip_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailInseam_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailLeadTime_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailLength_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailManufactureDate_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailMarkedSize_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailMaterialNotes_item",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "vertical",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailMedium_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailMetal_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailOrigin_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPeriod_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailProductionType_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailSeatHeight_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailSetSize_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShoulderToHem_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailStone_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailStoneCut_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailStyleOf_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailVersions_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailWaist_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailWear_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailWeight_item",
      "args": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
